import axios from "axios";

export const OBRASOCIAL_URL = `ObraSocial`;

export const obrasocialServices = {
  getActiveList: () => {
    return axios.get<any>(`${OBRASOCIAL_URL}/activas`);
  },
  getById: (id: string) => {
    return axios.get<any>(`${OBRASOCIAL_URL}/${id}`);
  },
  lookup: (queryParams?: any) => {
    return axios.get<any>(`${OBRASOCIAL_URL}/Lookup`, {});
  },
};
